import { Box, Button, Typography } from "@mui/material";
import { ButtonChangeCondition } from "./ButtonChangeCondition";
import { useConditionalContext } from "./ConditionalContext";

interface ConditionalControlsProps {
  isConditional: boolean;
  isEditingCondition: boolean;
  setEditingCondition: (value: ((prevState: boolean) => boolean) | boolean) => void;
  removeResult: () => void;
  canRemoveResult: boolean;
}

export function ConditionalControls(props: ConditionalControlsProps) {
  const { conditions, selectedCondition, addConditionalResult } = useConditionalContext();

  if (!props.isConditional) {
    return <></>;
  }

  return (
    <>
      {conditions!.length > 1 && (
        <Box className={"horizontal-flex"}>
          <ButtonChangeCondition delta={-1} />
          <Typography>
            {selectedCondition}/{conditions!.length - 1}
          </Typography>
          <ButtonChangeCondition delta={1} />
        </Box>
      )}
      <Button onClick={() => addConditionalResult()} variant={"outlined"}>
        Add conditional result
      </Button>
      {props.canRemoveResult && (
        <Button onClick={props.removeResult} variant={"outlined"} color={"error"}>
          Remove result
        </Button>
      )}
    </>
  );
}
